import getCustomOtherStylesRootRule from './get-custom-global-styles-root-rule';
import getCssVariablesMap from '../../text-formatting/helpers/custom-colors/get-css-variables-map';

const getCustomGlobalStylesVariables = () => {
  const rootRule = getCustomOtherStylesRootRule();

  if (!rootRule) {
    return {};
  }

  return getCssVariablesMap(rootRule.style.cssText);
};

export default getCustomGlobalStylesVariables;
